export default function () {
  var size = 0;
  this.each(function () {
    ++size;
  });
  return size;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/selection/size.js
// module id = 436
// module chunks = 0